import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Canonical uses the real production domain so imported/legacy URLs reclaim SEO value.
export const SITE_URL = "https://sanantonioswebdesign.com";
export const SITE_NAME = "San Antonio's Web Design";
export const DEFAULT_OG_IMAGE = SITE_URL + "/og-image.jpg";

/** Set per-page title, meta description, canonical, OpenGraph/Twitter and JSON-LD schema. */
export function useSeo({ title, description, path, image, type = "website", jsonLd, keywords,
                         noindex = false, publishedTime, modifiedTime } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", noindex ? "noindex,follow" : "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1");
    const canonical = path ? SITE_URL + path : undefined;
    upsertLink("canonical", canonical);
    const ogImage = image || DEFAULT_OG_IMAGE;
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:locale", "en_US");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type === "article" ? "article" : "website");
    if (canonical) upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", ogImage);
    if (type === "article") {
      upsertMeta("property", "article:published_time", publishedTime);
      upsertMeta("property", "article:modified_time", modifiedTime || publishedTime);
    }
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);

    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.id = "page-jsonld";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
    return () => {
      const s = document.getElementById("page-jsonld");
      if (s) s.remove();
    };
  }, [title, description, path, image, type, keywords, noindex, publishedTime, modifiedTime, JSON.stringify(jsonLd)]);
}
